
# Fehlermeldung bei ajax:error ausgeben
$(document.body).on "ajax:error", (event, xhr) ->
  if xhr.status == 401
    Application.loginRequired()
  else
    alert(xhr.responseText)
